export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_europedu-sandbox/artifacts/bzvxqtlb_europedu%20logo%20without%20background.png";

export const COMPANY = {
  name: "EuropEdu Ltd",
  tagline: "Unlock your global potential: your gateway to work and study abroad success.",
  intro:
    "EuropEdu Ltd is a job recruitment and overseas education consultancy that connects qualified professionals with opportunities in the United Kingdom, Australia and Europe, and guides students towards international educational experiences.",
  email: "contact@europedu.co.uk",
  phones: ["+44 7534 560 589", "+91 8111 902 999"],
};

export const WHY_EUROPEDU = [
  { title: "Expertise and experience", text: "Consultants with in-depth knowledge of international education systems, universities and job markets." },
  { title: "Personalised approach", text: "Guidance and support tailored to each client's specific requirements." },
  { title: "Extensive network", text: "Established connections with educational institutions and employers, giving clients a wide range of opportunities." },
  { title: "Quality assurance", text: "High standards in counselling, application assistance and visa support." },
  { title: "End-to-end support", text: "Comprehensive support from the first consultation through to post-arrival assistance." },
];

export const SERVICES = [
  { title: "Job search assistance", text: "Search vacancies, apply with a reusable profile and track every stage.", to: "/jobs" },
  { title: "Sponsorship-friendly jobs", text: "Evidence-based sponsorship labels with the source recorded for every classification.", to: "/sponsorship-jobs" },
  { title: "UK sponsor directory", text: "Search the official GOV.UK register of licensed sponsors with versioned change reports.", to: "/sponsors" },
  { title: "Founder and visa programmes", text: "Structured programme assessments, human review and future secure case workflows, starting with UK Innovator Founder.", to: "/programmes" },
  { title: "Resume and cover letter services", text: "ATS-friendly CV templates, keyword analysis and version history.", to: "/cv-builder" },
  { title: "Overseas education consultation", text: "Compare institutions and courses, each with a source and last-reviewed date.", to: "/study" },
  { title: "University application assistance", text: "Guided applications, document checklists and offer tracking.", to: "/study" },
  { title: "Visa and immigration support", text: "Structured UK visa information, cost calculator and regulated adviser support.", to: "/visas" },
  { title: "Document verification", text: "Scoped, paid verification with a versioned legal declaration and signed report.", to: "/verify" },
];

export const COURSE_GROUPS = [
  { title: "Courses for nurses", items: ["OET", "IELTS", "CBT", "OSCE", "NCLEX"] },
  { title: "Language programmes", items: ["ESOL", "Business English", "IELTS Academic"] },
  { title: "NVQ programmes", items: ["Health and Social Care", "Leadership", "Business Administration"] },
];

export const SECTORS = [
  "Accounting and finance",
  "Health and social care",
  "Industrial",
  "IT and digital",
  "Technical and engineering",
  "Logistics and transportation",
];
